<template lang="pug">
section.row.search
	loader(v-if="!loaded")
	.search__app(v-else)
		.hero.search__hero
			.hero__interiorContainer
				.container.search__container
					SearchBox(@submitsearch="submitSearch")
		.search__container
			.search__rail(v-if="settings.shouldFiltersBeShown")
				SearchFilters(@submitfilters="submitFilters")
			.search__main
				SearchFiltersTags(@submitfilters="submitFilters")
				template(v-for="result in results.itemResults")
					SearchResultDocument(
						:key="result.key", 
						:result="result")
				SearchPagination(
					v-if="settings.shouldHeaderBeShown",
					@submitpage="submitPage"
				)
</template>

<script>
import SearchFunctions from './mixins/SearchFunctions';
import SearchFiltersTags from './components/SearchFiltersTags';

export default {
	name: "SearchApp",
	components: {
		SearchFiltersTags,
	},
	mixins: [SearchFunctions],
	data() {
		return {};
	},
	computed: {},
	methods: {},
	created() {
		this.initialize();
	},
};
</script>

<style scoped lang="scss">
.search {
	display: flex;
	flex-direction: column;
	// margin-top: 1.875rem;

	&__app {
		@include mq(lg) {}
	}

	&__container {
		@include container();

		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;

		gap: 4rem;

		padding: 0;

		@include mq(lg) {
			flex-direction: row;
			align-items: stretch;
		}
	}

	&__main,
	&__rail {
		flex: 0 1 auto;
		width: 100%;

		overflow: hidden;
		
		margin: 0;

		&:nth-child(1) {
			@include mq(lg) {
				margin-left: 0;
			}
		}

		&:nth-child(2) {
			@include mq(lg) {
				margin-right: 0;
			}
		}

		&:only-child {
			@include mq(lg) {
				margin: 0;
			}
		}

		@include mq(lg) {
			margin: 0;

			width: auto;
		}
	}

	&__main {
		@include mq(lg) {
			flex: 0 1 100%;
		}
	}

	&__rail {
		@include mq(lg) {
			flex: 1 0 13.75rem;
		}
	}
}
</style>